module.exports = __webpack_public_path__ + "static/media/Downarrow.6bbb7aa2.svg";